<template>
  <button :class="buttonClass" @click="$emit('click')">
    <icon v-if="iconStart" :name="iconStart" />
    <span class="new-button__text">{{ text }}</span>
    <icon v-if="iconEnd" :name="iconEnd" />
  </button>
</template>

<script>
export default {
  props: {
    iconStart: {
      type: String,
      required: false
    },
    iconEnd: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => {
        return (
          ['extra-small', 'small', 'medium', 'large'].indexOf(value) !== -1
        );
      }
    },
    color: {
      type: String,
      default: 'primary',
      validator: value => {
        return (
          [
            'primary',
            'secondary',
            'tertiary',
            'success',
            'danger',
            'warning'
          ].indexOf(value) !== -1
        );
      }
    }
  },
  computed: {
    buttonClass() {
      return ['new-button', this.size, this.color];
    },
    iconClass() {
      return ['icon', this.icon];
    }
  }
};
</script>

<style scoped lang="scss">
.new-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: 0.3s;
  &.primary {
    background: #409fff;
    color: #fff;
    stroke: #fff;
    border: 2px solid #409fff;
    &:hover {
      background: #409fff;
      border-color: #409fff;
      color: #fff;
      stroke: #fff;
      box-shadow: 0px 6px 10px rgba(9, 131, 255, 0.5);
    }
    &:focus {
      background: #409fff;
      box-shadow: none;
      color: #fff;
      stroke: #fff;
    }
    &:active {
      border-color: #0077ef;
      background: #0077ef;
      box-shadow: none;
      color: #fff;
      stroke: #fff;
    }
    &:disabled {
      background: #e3e7ee;
      border-color: #e3e7ee;
      pointer-events: none;
      color: #8e9ebb;
      stroke: #8e9ebb;
    }
  }
  &.secondary {
    border: 1px solid #5a6f95;
    background-color: transparent;
    stroke: #5a6f95;
    &:hover {
      border-color: #0077ef;
      stroke: #0077ef;
      color: #0077ef;
    }
    &:focus {
      border-color: #0077ef;
      stroke: #0077ef;
      color: #0077ef;
    }
    &:active {
      border-color: #0077ef;
      background: #cfe7ff;
      stroke: #0077ef;
      color: #0077ef;
    }
    &:disabled {
      background: #e3e7ee;
      border-color: #e3e7ee;
      color: #8e9ebb;
      stroke: #8e9ebb;
    }
  }
  &.tertiary {
    color: #38455d;
    stroke: #38455d;
    background-color: transparent;
    &:hover {
      background: #eef7ff;
      color: #0077ef;
      stroke: #0077ef;
    }
    &:focus {
      background: #eef7ff;
      color: #0077ef;
      stroke: #0077ef;
    }
    &:active {
      background: #cfe7ff;
      color: #0077ef;
    }
    &:disabled {
      background: #e3e7ee;
      border-color: #e3e7ee;
      color: #8e9ebb;
      stroke: #8e9ebb;
    }
  }
  &.success {
    background: #29cc44;
    color: #fff;
    stroke: #fff;
    border: 2px solid #29cc44;
    &:hover {
      background: #29cc44;
      border-color: #29cc44;
      color: #fff;
      stroke: #fff;
    }
    &:focus {
      background: #29cc44;
      box-shadow: none;
      color: #fff;
      stroke: #fff;
    }
    &:active {
      border-color: #1da834;
      background: #1da834;
      box-shadow: none;
      color: #fff;
      stroke: #fff;
    }
    &:disabled {
      background: #e3e7ee;
      border-color: #e3e7ee;
      pointer-events: none;
      color: #8e9ebb;
      stroke: #8e9ebb;
    }
  }
  &.large {
    padding: 0 32px;
    height: 56px;
  }
  &.medium {
    height: 48px;
    padding: 0 32px;
  }
  &.small {
    height: 40px;
    padding: 0 24px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  &.extra-small {
    height: 32px;
    padding: 0 12px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
